import { render } from "./FormPruefprotokoll_Rolltore.vue?vue&type=template&id=fe0d7d34&scoped=true"
import script from "./FormPruefprotokoll_Rolltore.vue?vue&type=script&lang=js"
export * from "./FormPruefprotokoll_Rolltore.vue?vue&type=script&lang=js"

import "./FormPruefprotokoll_Rolltore.vue?vue&type=style&index=0&id=fe0d7d34&lang=scss&scoped=true"

import exportComponent from "/home/hiro/lab/hands4you-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe0d7d34"]])

export default __exports__